import { push } from 'connected-react-router'
import { put, takeEvery } from 'redux-saga/effects'
import { RehydrateAction } from 'redux-persist/es/types'

function* moveToLatestPosition(action: RehydrateAction) {
  yield put(push(action.payload.router.location.pathname))
}

export function* watchForRehydration() {
  yield takeEvery<RehydrateAction>(
    (action: RehydrateAction) =>
      /REHYDRATE$/.test(action.type) &&
      action.payload &&
      action.payload.router &&
      action.payload.router.location.pathname,
    moveToLatestPosition
  )
}
